import I18n from 'i18n-js';
import { Globals } from 'react-spring';

import * as errorReporting from 'hb-react/shared/utils/errorReporting';
import { DATE_FORMAT_FALLBACKS } from 'initializers/dateFormatFallbacks';
import initGettext from 'initializers/gettext';

// Empty translations config for gettext fallback - returns original key when no translation found
// Will be re-initialized with real translations when locale chunk loads
const EMPTY_GETTEXT_TRANSLATIONS = {
  locale_data: {
    messages: {
      '': {
        domain: 'messages',
        lang: 'en',
        // eslint-disable-next-line camelcase
        plural_forms: 'nplurals=2; plural=(n != 1);',
      },
    },
  },
  domain: 'messages',
};

// Initialize I18n globally so it's available before locale chunks load
window.I18n = I18n;

// Return the key itself when translation is missing (instead of "[missing ... translation]")
// This ensures graceful fallback before locale chunk loads and keeps tests passing
// Special handling for date format keys to avoid breaking date pickers
I18n.missingTranslation = (scope) => DATE_FORMAT_FALLBACKS[scope] ?? scope;

// Initialize gettext with fallback translations
initGettext(EMPTY_GETTEXT_TRANSLATIONS);

// This variable is injected by webpack with all env variables need for the project
// eslint-disable-next-line no-undef
const envs = __HB_ENV__;

// Don't do that on Storybook
if (!process.env.STORYBOOK_ENV) {
  // Change the public path "On The Fly" https://webpack.js.org/guides/public-path/#on-the-fly
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = window.__HB_ENV__.PUBLIC_PATH;
}

if (process.env.STORYBOOK_ENV) {
  // eslint-disable-next-line no-undef
  window.__HB_ENV__ = __HB_ENV__;
}

errorReporting.initSentry(window.__HB_ENV__);

// Set some context for Sentry from this file app/views/layouts/_javascripts.html.haml
if (window.__HB_USER__ || window.__HB_NETWORK__) {
  errorReporting.setContext({
    ...(window.__HB_USER__ && {
      user: window.__HB_USER__,
    }),
    ...(window.__HB_NETWORK__ && {
      network: window.__HB_NETWORK__,
    }),
  });
}

const isTest = envs.ENVIRONMENT === 'test';

// Skip all animation from react-spring on e2e tests
if (isTest) {
  Globals.assign({
    skipAnimation: true,
  });
}
